import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=0247598d&scoped=true&functional=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=0247598d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "0247598d",
  null
  
)

export default component.exports